module.exports = __webpack_public_path__ + "web/static/img/ajax.9b3d2ed6.png";